import { type FC } from "react";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { Icon } from "@root/shared/components/Icon";
import { TextLink } from "@root/shared/components/TextLink";
import * as styles from "./styles.css";

const MHLW_MINIMUM_WAGE_URL =
  "https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/koyou_roudou/roudoukijun/minimumichiran/index.html";

type Props = {
  // 案内対象求人の区分見出し（掲載中求人 / 応募停止求人）
  sectionTitle: string;
  // 求人コード(業種×職種) の表示文字列
  workLabels: string[];
};

export const GuidanceBoxForBelowMinWage: FC<Props> = ({ sectionTitle, workLabels }) => (
  <GuidanceBox themeColor="red" className={styles.box}>
    <p className={styles.title}>【重要】最低賃金を下回る恐れがある求人があります。</p>
    <p className={styles.text}>
      以下の求人広告の給与金額および給与の備考において、法令に抵触する可能性がございます。必ずご確認をお願いいたします。
    </p>
    <p className={styles.text}>
      <strong>＜該当求人広告：{workLabels.length}求人＞</strong>
      <br />
      <strong>■{sectionTitle}</strong>
      <br />
      {workLabels.join("、")}
    </p>
    <p className={styles.text}>
      <strong>【ご注意事項】</strong>
      <br />
      ※ 修正内容の承認・更新が完了した時点で、本アラートは自動的に消去されます。
      <br />
      ※
      法令遵守のため、期限までに修正が確認できない場合、弊社にて最低賃金額への自動補正、または掲載停止の措置をとる場合がございます。
      <br />※ 掲載停止となった場合でも、ご契約プランに応じたシステム利用料が発生いたします。
    </p>
    <p className={styles.text}>
      <TextLink
        icon={<Icon name="target-blank" />}
        href={MHLW_MINIMUM_WAGE_URL}
        target="_blank"
        rel="noopener"
        className={styles.textLink}
      >
        厚生労働省{"\u3000"}地域別最低賃金の全国一覧はこちら
      </TextLink>
    </p>
  </GuidanceBox>
);
